import pythonApiClient from './pythonBaseApi';

// Usar cliente base compartido de Python API
const basePath = '/mantenimientos/tipos-servicios-alimentacion-origen';

export const tipoServicioAlimentacionOrigenApi = {
  // Obtener relaciones por cliente (proyecto viene del header X-Proyecto-ID)
  getByCliente: async (clienteId) => {
    const response = await pythonApiClient.get(`${basePath}/?cliente_id=${clienteId}`);
    return response.data;
  },

  // Crear relación (proyecto viene del header X-Proyecto-ID)
  create: async (data) => {
    const response = await pythonApiClient.post(`${basePath}/`, data);
    return response.data;
  },

  // Eliminar relación (proyecto viene del header X-Proyecto-ID)
  delete: async (clienteId, tipoServicioAlimentacionId, tipoOrigenId) => {
    const response = await pythonApiClient.delete(
      `${basePath}/?cliente_id=${clienteId}&tipo_servicio_alimentacion_id=${tipoServicioAlimentacionId}&tipo_origen_id=${tipoOrigenId}`
    );
    return response.data;
  },
};

